module.exports = __webpack_public_path__ + "static/material-icons-regular-012cf6a10129e2275d79d6adac7f3b02.woff";